import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Nav, Navbar, NavDropdown, Image } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import ChangePassword from '../components/navbars/ChangePassword';
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo'
import { withRouter } from "react-router-dom";
import parse, { domToReact } from 'html-react-parser';
import Notification from '../components/navbars/Notification';
import BrandLogo from "../components/navbars/BrandLogo";
import '../components/navbars/_navbars.scss';
import { brandLoginUrl } from "../../utils/brandLogin";


const FETCH_GLOBALS = gql` 
query($mobile: String) {
    studentGlobals(mobile: $mobile){
        examInstructions{
            is_exam
            instructions
        }
     }
}

`;

class PracticeInstructions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false
        }
    }
    logout = () => {
        if (Cookies.get("studenttoken") !== undefined) {
            Cookies.remove("studenttoken");
            Cookies.remove("studentusername");
            Cookies.remove("studentrefreshtoken");
            Cookies.remove("studentemail");
            Cookies.remove("mobile");
            Cookies.remove("classid");
            Cookies.remove("examid");
            Cookies.remove("mobileverified");
            Cookies.remove("targetyear");
            Cookies.remove("role");
            if (brandLoginUrl(Cookies.get("institution_id"))) {
                window.location.href = brandLoginUrl(Cookies.get("institution_id"));
            } else {
                this.props.history.push("/student/login");
            }
        }
    };
    newTabFunction = () => {
        localStorage.setItem("subjectid", (this.props.history.location.state || {}).subjectid);
        localStorage.setItem("type", "practice");
        localStorage.setItem("ocid", (this.props.history.location.state || {}).ocid);
        localStorage.setItem("otid", (this.props.history.location.state || {}).otid);
        localStorage.setItem("hchaptername", (this.props.history.location.state || {}).hchaptername);
        localStorage.setItem("practice_type", 1);

        window.open("http://localhost:3000/student/subject/practice-test", "_blank") //to open new page
    }
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        console.log("PracticeInstructions", this.props.history.location.state);
        let canceltype = "";
        if ((this.props.history.location.state || {}).etype == "strengthanalysis") {
            canceltype = "strengthanalysis";
        }
        else if ((this.props.history.location.state || {}).etype == "examanalysis") {
            canceltype = "examanalysis";
        }
        else if ((this.props.history.location.state || {}).etype == "homedata") {
            canceltype = "homedata";
        }
        else {
            canceltype = "normal";
        }
        console.log("PracticeInstructions", this.props);

        const studentGlobals = this.props.studentGlobals;
        const loading5 = studentGlobals.loading;
        const error5 = studentGlobals.error;



        if (loading5) return <PreloaderTwo />;
        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }

        const instructions = studentGlobals.studentGlobals.examInstructions.find((a) => a.is_exam == "0");
        return (
            <div className="PracticeInstructions header-top">
                <Navbar className="navbar navbar-expand-md navbar-white bg-white shadow-sm">
                    <Container fluid>
                        <Link to="/student/home">
                            <BrandLogo width="159.501" />
                        </Link>

                        <Nav className="ml-auto">
                            <Notification />
                            <NavDropdown id="basic-nav-dropdown2" className="no-arrow" alignRight title={
                                <div className="profile-img d-flex align-items-center">
                                    {localStorage.getItem("profile_pic") ? (

                                        <Image src={`https://support.rizee.in/files/${localStorage.getItem("profile_pic")}`} roundedCircle alt="profile-img" onError={(e) => { e.target.onerror = null; e.target.src = require('../../images/businessman.png'); }} />
                                    ) : (
                                            <Image src={require('../../images/businessman.png')} roundedCircle alt="profile-img" />
                                        )}

                                    <div className="text mx-2 mt-2">
                                        <div className="profile-name">{Cookies.get("studentusername")}</div>
                                        <small>Branch- {Cookies.get("branch_name")}, Class - {Cookies.get("class_id") == "1" ? ("XI") : ("XII")}</small>
                                    </div>
                                </div>
                            }>
                                <NavDropdown.Item className="font-weight-bold">{Cookies.get("studentemail")}</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item as={Link} to="/student/profile"><i className="far fa-user mr-2" /> My Profile</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="#"><i className="far fa-user-chart mr-2" /> Status</NavDropdown.Item>
                                <NavDropdown.Item onClick={() => this.setState({ modalShow: true })}><i className="far fa-key mr-2" /> Change Password</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="#"><i className="far fa-comment-alt-lines mr-2" /> Feedback</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item as={Link} onClick={this.logout}><i className="far fa-sign-out mr-2" /> Logout</NavDropdown.Item>
                            </NavDropdown>

                        </Nav>
                    </Container>
                </Navbar>
                <div className="bg-success py-3">
                    <Container fluid className="d-flex justify-content-between align-items-center">
                        {(this.props.history.location.state || {}).etype == "chapter" ? (
                            <Link to={{
                                pathname: "/student/subjects",
                                state: {
                                    chapters1: (this.props.history.location.state || {}).chapters.chapters1,
                                    subject: (this.props.history.location.state || {}).chapters.subject,
                                    subjectid: (this.props.history.location.state || {}).chapters.subjectid,
                                    getSubjects: (this.props.history.location.state || {}).chapters.getSubjects,
                                    subjectindex: (this.props.history.location.state || {}).chapters.subjectindex,
                                    practice_percentage: (this.props.history.location.state || {}).chapters.practice_percentage,
                                    htitle: (this.props.history.location.state || {}).chapters.htitle,
                                    htitlecount: (this.props.history.location.state || {}).chapters.htitlecount,
                                    totquestions: (this.props.history.location.state || {}).chapters.totquestions,
                                }
                            }} className="my-0 font-weight-normal text-light">
                                <i className="fal fa-arrow-left" /> Back</Link>
                        ) :
                            (this.props.history.location.state || {}).etype == "strengthanalysis" ? (
                                <Link to={{
                                    pathname: "/student/strength-analysis"
                                }} className="my-0 font-weight-normal text-light">
                                    <i className="fal fa-arrow-left" /> Back</Link>
                            ) :
                                (this.props.history.location.state || {}).etype == "homedata" ? (
                                    <Link to={{
                                        pathname: "/student/home"
                                    }} className="my-0 font-weight-normal text-light">
                                        <i className="fal fa-arrow-left" /> Back</Link>
                                )
                                    :
                                    (this.props.history.location.state || {}).etype == "examanalysis" ? (
                                        <Link to={{
                                            pathname: "/student/practice-exam-analysis"
                                        }} className="my-0 font-weight-normal text-light">
                                            <i className="fal fa-arrow-left" /> Back</Link>
                                    ) : (
                                            <Link to={{
                                                pathname: "/student/subjects",
                                                state: {
                                                    chapters1: (this.props.history.location.state || {}).chapters.chapters1,
                                                    subject: (this.props.history.location.state || {}).chapters.subject,
                                                    subjectid: (this.props.history.location.state || {}).chapters.subjectid,
                                                    getSubjects: (this.props.history.location.state || {}).chapters.getSubjects,
                                                    subjectindex: (this.props.history.location.state || {}).chapters.subjectindex,
                                                    practice_percentage: (this.props.history.location.state || {}).chapters.practice_percentage,
                                                    htitle: (this.props.history.location.state || {}).chapters.htitle,
                                                    htitlecount: (this.props.history.location.state || {}).chapters.htitlecount,
                                                    totquestions: (this.props.history.location.state || {}).chapters.totquestions,

                                                }
                                            }} className="my-0 font-weight-normal text-light">
                                                <i className="fal fa-arrow-left" /> Back</Link>
                                        )}

                        <div className="my-2 my-md-0 text-center">
                            <h6 className="title mb-0 mr-4 text-white">Instruction</h6>
                        </div>
                        <div>&nbsp;</div>
                    </Container>
                </div>
                <div className="content-box mt-5" style={{ height: '100vh' }}>
                    <Container fluid>
                        <Row>
                            <Col xl={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} md={{ span: 10, offset: 1 }} sm={12}>
                                <h6 className="mb-2"><u>Please read the following instructions carefully.</u></h6>
                                {parse(instructions.instructions)}
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-white py-3 border-top shadow-sm">
                    <Container>
                        <Row>
                            {(this.props.history.location.state || {}).type == "error" ? (<Col xl={12} lg={12} md={12} className="text-right">
                                <Link
                                    to={{
                                        pathname: "/student/subject/practice-errortest",
                                        state: {
                                            chapters: (this.props.history.location.state || {}).chapters,
                                            ocid: (this.props.history.location.state || {}).ocid,
                                            otid: "0",
                                            hchaptername: (this.props.history.location.state || {}).hchaptername,
                                            subjectid: (this.props.history.location.state || {}).subjectid,
                                            stateData: (this.props.history.location.state || {}).stateData,
                                            type: "error"
                                        }
                                    }}

                                    className="btn btn-outline-primary px-5">Start Practice</Link>
                            </Col>) : (<Col xl={12} lg={12} md={12} className="text-right">
                                <a
                                    // to={{
                                    //     pathname: "/student/subject/practice-test",
                                    //     state: {
                                    //         canceltype: canceltype,
                                    //         chapters: (this.props.history.location.state || {}).chapters,
                                    //         ocid: (this.props.history.location.state || {}).ocid,
                                    //         otid: (this.props.history.location.state || {}).otid,
                                    //         hchaptername: (this.props.history.location.state || {}).hchaptername,
                                    //         subjectid: (this.props.history.location.state || {}).subjectid,
                                    //         type: "practice"
                                    //     }
                                    // }}
                                    //target="_blank"
                                    onClick={(e) => this.newTabFunction()}

                                    className="btn btn-outline-primary px-5">Start Practice</a>
                            </Col>)}

                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}


export default withRouter(compose(
    graphql(FETCH_GLOBALS,
        {
            options: props => ({
                variables: {
                    mobile: Cookies.get("mobile")
                },
                fetchPolicy: "cache-and-network"
            }), name: "studentGlobals"
        }))(PracticeInstructions));
